/**
 * Wellness nav constants
 */
export const WELLNESS_ITEM_ID = '221'
export const GROVE_WELLNESS_LOGO_IMAGE =
  'https://images.grove.co/upload/f_auto,fl_progressive,w_560,q_auto/global/Logos/Regular/Grove-Wellness-logo_cream.png'
export const FEEL_GOOD_WELLNESS_STANDARD_LOGO_IMAGE =
  'https://images.grove.co/upload/f_auto,fl_progressive,w_476,q_auto/global/Logos/Regular/Feel-Good-Wellness-Standard-Logo.png'
